// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AttachIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 24 24">
    <path d="m20.8 9.94-9.55 9.57a5.43 5.43 0 0 1-7.67-7.66l5.27-5.27a.67.67 0 0 1 .95 0c.27.27.27.7 0 .96L4.54 12.8a4.06 4.06 0 0 0 5.73 5.73l9.57-9.57a2.7 2.7 0 0 0 0-3.82 2.7 2.7 0 0 0-3.82 0L6.47 14.7a1.34 1.34 0 0 0 0 1.91c.53.54 1.38.54 1.91 0l8.13-8.13a.67.67 0 0 1 .96 0c.26.27.26.7 0 .96l-8.13 8.13a2.7 2.7 0 0 1-3.82 0 2.7 2.7 0 0 1 0-3.82l9.57-9.58a4.06 4.06 0 1 1 5.7 5.76" />
  </svg>,
  "Attach",
);
export default AttachIcon;
